module.exports = __webpack_public_path__ + "img/logo-iph-hori-v1.2eee3ece.png";